const ABAC_DATA_PERMISSIONS_FEATURES = (window.ENVS
  .ABAC_PERMISSIONS_DATA_FEATURES || []) as Array<string>;

export const getAbacPermissionsDataFeatures = (supplierId: string) =>
  ABAC_DATA_PERMISSIONS_FEATURES.map((featureKey) => ({
    scope: window.ENVS.MAIN_ABAC_SCOPE,
    featureKey,
    key: supplierId,
  }));
